import React from "react";

const Footer = () => {
    return (
        <div className="bg-black h-60 ">
            <p className="text-center pt-52 text-sm  text-gray-400">
                &copy; 2024 Movieflix
            </p>
        </div>
    );
};

export default Footer;
